import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
  },

  line: {
    width: 89,
    borderTopWidth: 2,
    borderColor: '#ffffff',
    marginTop: 20,
    marginBottom: 20,
  },

  contentWrapper: {
    paddingHorizontal: 40,
    marginTop: 20,
    width: '100%',
  },

  columnsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 20,
    width: '100%',
    marginTop: 20,
    marginLeft: 5,
  },

  leftColumn: {
    width: 242,
  },

  rightColumn: {
    width: 219,
  },

  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 900,
  },

  titleUnderline: {
    width: 89,
    borderTopWidth: 2,
    marginTop: 15,
    marginBottom: 15,
  },

  description: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 12,
    textAlign: 'left',
  },

  itemTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 9,
    textAlign: 'left',
  },
  itemText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 9,
    textAlign: 'left',
  },
  coLocatedWithTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 11,
    textAlign: 'left',
  },

  eventLogo: {
    width: 209,
    height: 110,
    objectFit: 'contain',
  },

  image: {
    width: 173,
    height: 52,
    objectFit: 'contain',
    borderRadius: 4,
  },

  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    paddingVertical: 7,
    border: `1px solid #27343D`,
    borderRadius: 2,
    width: 126,
  },
  linkText: {
    color: '#27343D',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 9,
    textDecoration: 'none',
  },

  testimonialsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    width: '100%',
  },

  testimonialItemWrapper: {
    display: 'flex',
    flexDirection: 'column',

    border: '1px solid #EDEDED',
    borderRadius: 4,
    width: 165,
    height: 136,
  },

  testimonialCitation: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',

    paddingHorizontal: 5,
    paddingVertical: 3,

    color: '#27343D',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 8,
    textAlign: 'center',
  },

  testimonialCompanyLogo: {
    width: 165,
    height: 33,
    objectFit: 'contain',
    paddingVertical: 3,
  },

  testimonialFooterWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',

    height: 80,
    paddingVertical: 5,
    paddingHorizontal: 5,

    backgroundColor: '#27343D',
    color: 'white',
    borderTop: '2px solid #EDEDED',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },

  testimonialJobTitleText: {
    color: 'white',
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 8,
    textAlign: 'center',
  },

  testimonialCompanyNameText: {
    color: 'white',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 6,
    textAlign: 'center',
  },
});
